import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Save, RotateCcw, Loader2 } from 'lucide-react'

interface RemakeToolbarProps {
  onSave: () => void
  onReset: () => void
  isDirty: boolean
  isSaving: boolean
  saveDisabled?: boolean
  saveDisabledReason?: string
}

export function RemakeToolbar({ onSave, onReset, isDirty, isSaving, saveDisabled, saveDisabledReason }: RemakeToolbarProps) {
  const { t } = useTranslation()
  const [confirmReset, setConfirmReset] = useState(false)
  const r = (key: string) => t(`remake.${key}`)

  const handleReset = () => {
    if (confirmReset) { onReset(); setConfirmReset(false) }
    else setConfirmReset(true)
  }

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onSave}
        disabled={!isDirty || isSaving || saveDisabled}
        title={saveDisabled ? saveDisabledReason : undefined}
        className="flex items-center gap-1.5 px-4 py-2 text-sm rounded-lg bg-orange-500 text-white hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSaving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
        {isSaving ? r('saved') : r('save')}
      </button>
      <button
        onClick={handleReset}
        onBlur={() => setConfirmReset(false)}
        disabled={!isDirty}
        className="flex items-center gap-1.5 px-4 py-2 text-sm rounded-lg border border-neutral-300 dark:border-neutral-600 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <RotateCcw className="w-4 h-4" />
        {confirmReset ? r('resetConfirm') : r('reset')}
      </button>
    </div>
  )
}
